import { render } from "./DelvCalender.vue?vue&type=template&id=2ec9b833&scoped=true"
import script from "./DelvCalender.vue?vue&type=script&lang=js"
export * from "./DelvCalender.vue?vue&type=script&lang=js"

import "./DelvCalender.vue?vue&type=style&index=0&id=2ec9b833&lang=css"
import "./DelvCalender.vue?vue&type=style&index=1&id=2ec9b833&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ec9b833"]])

export default __exports__